/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import { navigate } from "gatsby";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box,  } from "@theme-ui/components";
import { InputBox } from "./index";

const SearchBox = ({ customStyles, searchURL, placeholder, rightIconName }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm !== "") {
      navigate(searchURL + searchTerm);
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} sx={customStyles}>
      <InputBox
        type="text"
        value={searchTerm}
        placeholder={placeholder}
        onChange={(e) => setSearchTerm(e.target.value)}
        rightIconName={rightIconName}
        onClick={handleSubmit}
      />
    </Box>
  );
};

SearchBox.propTypes = {
  customStyles: PropTypes.object,
  searchURL: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rightIconName: PropTypes.string,
};
  
SearchBox.defaultProps = {
  searchURL: "",
  customStyles: {},
  placeholder: "Search",
  rightIconName: "Search",
};

export default SearchBox;
